var map = {
	"./component/component.module": [
		"./src/app/components/design-system/component/component.module.ts",
		"component-component-module"
	],
	"./components/intake/intake.module": [
		"./src/app/components/intake/intake.module.ts",
		"components-intake-intake-module"
	],
	"./design/design.module": [
		"./src/app/components/design-system/design/design.module.ts",
		"design-design-module"
	],
	"./webhook/webhook.module": [
		"./src/app/components/jubili/webhook/webhook.module.ts",
		"webhook-webhook-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;